module.exports = __webpack_public_path__ + "static/img/about-us-logo.188de75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about-us-logo.png
// module id = 1amO
// module chunks = 0